import React, { useState, useMemo } from 'react'
import { useAnnouncements } from './hooks/useAnnouncements'

const MAX_VISIBLE_DEFAULT = 2

export default function AnnouncementsContainer({ maxVisible = MAX_VISIBLE_DEFAULT, sticky = false, refreshInterval, seenDelayMs }) {
  const { banners, markSeen, dismiss, hasAuth } = useAnnouncements({ enabled: true, refreshInterval })
  const [expanded, setExpanded] = useState(false)
  const { primary, hiddenCount, hidden } = useMemo(() => {
    if (expanded) return { primary: banners, hiddenCount: 0, hidden: [] }
    const primary = banners.slice(0, maxVisible)
    const hidden = banners.slice(maxVisible)
    return { primary, hiddenCount: hidden.length, hidden }
  }, [banners, expanded, maxVisible])
  if (!hasAuth || !banners.length) return null
  return (
    <div className={`announcements-container ${sticky ? 'announcements-sticky' : ''}`} data-testid='announcements-container'>
  {primary.map(b => <Announcement key={b.data.id} banner={b} onSeen={markSeen} onDismiss={dismiss} seenDelayMs={seenDelayMs} />)}
      {!expanded && hiddenCount > 0 && (
        <button type='button' className='btn btn-link p-0 mt-1 announcement-expand' data-testid='announcements-expand' aria-label={`Visa fler systemmeddelanden (${hiddenCount})`} onClick={() => setExpanded(true)}>
          Visa fler ({hiddenCount})
        </button>
      )}
  {expanded && hidden.map(b => <Announcement key={b.data.id} banner={b} onSeen={markSeen} onDismiss={dismiss} seenDelayMs={seenDelayMs} />)}
  {expanded && banners.length > maxVisible && (
        <button type='button' className='btn btn-link p-0 mt-1 announcement-collapse' data-testid='announcements-collapse' aria-label='Visa färre systemmeddelanden' onClick={() => setExpanded(false)}>
          Visa färre
        </button>
      )}
    </div>
  )
}

const Announcement = (props) => {
  const { AnnouncementBanner } = require('./AnnouncementBanner')
  return <AnnouncementBanner {...props} />
}
